/* app/ui/arohaItinerary/itinerary */

define(
	'app/ui/arohaItinerary/itinerary',[
		'jquery',
		'util/mediaqueries',
		'util/core',
		'pubsub'
	],
	function ($, MediaQueries, Core) {

		window.dataLayer = window.dataLayer || [];

		var Itinerary;

		var firstLoad = true;
		var $itinerary;
		var $itineraryContainer;
		var $mapContainer;
		var $mapWrapper;
		var baseJsonUrl;
		var feedData = {};
		var queryObj = {};
		var mapHeight;
		var $closeBtn;
		var $mapToggleBtn;

		return {
			init: function ($map) {
				Itinerary = this;
				$itinerary = $map.closest('.js-itinerary');

				$itineraryContainer = $itinerary;
				baseJsonUrl = $itinerary.data('json-url');
				queryObj = Core.getQueryStringObject();
				$mapContainer = $('.js-itinerary-map');
				$closeBtn = $itinerary.find('.js-map-close');
				$mapToggleBtn = $itinerary.find('.js-map-toggle');

				var firstFetchUrl = baseJsonUrl;
				if (baseJsonUrl !== '') {
					if (queryObj.queryString !== '') {
						firstFetchUrl += '&' + queryObj.queryString;
					}
					Itinerary._fetchFeedData(firstFetchUrl);
				}

				Itinerary._initElements();
				Itinerary._initEvents();
				Itinerary._initMediaQueries();
			},

			_initElements: function () {
				$mapContainer = $('.js-itinerary-map');
				$mapWrapper = $('.js-itinerary-map-wrapper'); // Doesn't become sticky
			},

			_initEvents: function () {
				window.onpopstate = Itinerary._processPopState;

				$mapToggleBtn.on('click', Itinerary._mapToggleOpen);
				$closeBtn.on('click', Itinerary._mapToggleClose);
			},

			_stickyMap: function () {
				var mapHeight = $mapContainer.outerHeight();

				setTimeout(function () {
					mapHeight = $mapContainer.outerHeight();
				}, 3000);

				var containerHeight = $itineraryContainer.outerHeight();

				var itineraryContainerPosition = (containerHeight + $itineraryContainer.offset().top);

				var triggerPoint = Math.ceil(($(window).height() - 40));

				$mapContainer.width($mapContainer.outerWidth());

				var end = itineraryContainerPosition;

				if (mapHeight < containerHeight) {

					$(window).scroll(function () {
						var marginTop = $(this).scrollTop();

						var newItineraryContainerPosition = ($itineraryContainer.outerHeight() + $itineraryContainer.offset().top);

						if (itineraryContainerPosition != newItineraryContainerPosition) {
							end = newItineraryContainerPosition;
						}

						var mapPosition = $mapWrapper.offset().top;
						if (marginTop > mapPosition && marginTop < (end - triggerPoint) ) {
							$mapContainer.addClass("is_sticky-top");
							$mapContainer.removeClass("is_sticky-bottom");
						} else if (marginTop > (end - triggerPoint)) {
							$mapContainer.removeClass("is_sticky-top");
							$mapContainer.addClass("is_sticky-bottom");
						} else {
							$mapContainer.removeClass("is_sticky-top");
							$mapContainer.removeClass("is_sticky-bottom");
						}
					});
				}
			},

			_initMediaQueries: function () {
				MediaQueries.register([
					{
						queries: MediaQueries.queries['megamenu--large'],
						shouldDegrade: true,
						match: function () {
							Itinerary._stickyMap();
						}
					}
				]);
			},

			_processPopState: function (event) {
				var state = event.state;
				if (state) {
					feedData = state.data;
					//$.publish('/operator/feed/loaded', [feedData]);
				}
			},

			// Update listing when new filters are applied
			_initListing: function(queryData) {
				queryObj = queryData;
				fromHistory = false;

				var url = baseJsonUrl + '&' + queryObj.queryString;
				Itinerary._fetchFeedData(url);
			},

			// Fetch feed data from AjaxController
			_fetchFeedData: function(url) {
				$.ajax({
						url: url,
						dataType: 'json'
					})
					.done(
						Itinerary._fetchFeedDataComplete
					)
					.fail(
						Itinerary._fetchFeedDataError
					);
			},

			// Process feed data
			_fetchFeedDataComplete: function(data) {
				feedData = data;
				var hasResults = feedData.length >= 1;

				if (firstLoad) {
					feedData.queryObj = Core.getQueryStringObject();
				} else {
					feedData.queryObj = queryObj;
				}

				feedData.hasResults = hasResults;
				feedData.noResults = !hasResults;
				feedData.itinerary = true;

				$.publish('/map/interactive/opened');
				$.publish('/operator/feed/loaded', [feedData]);
			},

			_fetchFeedDataError: function() {
				console.error('There was an error retrieving feed data.');
			},

			_mapToggleOpen: function (event) {
				$mapContainer.addClass('o-overlay');

				if ($mapContainer.hasClass('o-overlay')) {
					$.publish('/map/interactive/opened');
						$.publish('/map/fitBounds');
				}

			},

			_mapToggleClose: function (event) {
				$mapContainer.removeClass('o-overlay');
			}

		};
	}
);
